import React, { useEffect, useState } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

import useAuth from "hooks/useAuth"

import api from "assets/services/api";


function ModalAddCommentStorage(props) {


    Date.prototype.withoutTime = function () {
        var d = new Date(this);
        d.setHours(0, 0, 0, 0);
        return d;
    }

    const [br, setBR] = React.useState(false);

    const [text, setText] = useState();
    const [controlSnack, setControlSnack] = useState(false);
    const { storageId } = useAuth();


    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };


    useEffect(() => {
    }, []);

    useEffect(() => {
        if(controlSnack){
            showNotification("br")
        }
    }, [controlSnack]);

    async function handleAddComment(e) {
        e.preventDefault();
        let comment;
        switch(props.type){
            case"storage": {
                comment = await api.post('/message/'+props.type,{
                    id_operator: props.props.id_admin,
                    id_storage: props.props.id,
                    text: text
                });
            } 
            case"sell": {
                comment = await api.post('/message/'+props.type,{
                    id_operator: props.props.id_admin,
                    id_sell: props.props.id,
                    text: text
                });
            }
        }
        if (comment.status === 200) {
            setControlSnack(true);
            props.onHide();
          }
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Adicionar comentário
          </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleAddComment}>
                <Modal.Body>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridText">
                            <Form.Label>Mensagem</Form.Label>
                            <Form.Control onChange={event => setText(event.target.value)} type="text" placeholder="Mensagem contendo o que há de errado" />
                        </Form.Group>
                    </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button color="success" type="submit" onClick={controlSnack ? () => showNotification("br") : () => showNotification("nf")}>
                            Adicionar
                        </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message="Mensagem adicionada com sucesso"
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalAddCommentStorage;